// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-confirm-alert/src/react-confirm-alert.css
// module id = 2810
// module chunks = 0